import { Component, computed, input } from '@angular/core';

import { ExternalLink } from '../../interfaces/external-link.interface';

interface ExternalLinkContent {
  url: string;
  teaserTitle: string;
}

@Component({
  selector: 'cms-external-link',
  template: '<fin-external-link [link]="link()" />',
  standalone: false,
})
export class CmsExternalLinkComponent {
  content = input.required<ExternalLinkContent>();

  link = computed<ExternalLink>(() => {
    return {
      url: this.content().url,
      text: this.content().teaserTitle,
      target: '_blank',
    };
  });
}
